import { getDefaultValue } from 'src/components/shared/form-elements';
import { FormInput } from '../../../../../@types';
import { SustainabilityScanFormFields } from '../types';
import { IntlShape } from 'react-intl/src/types';

export const useSustainabilityScanFormFieldsConfig = (intl: IntlShape) => {
  const sustainabilityScanFormFieldsConfig: Record<keyof SustainabilityScanFormFields, FormInput> =
    {
      acceptShareDetails: {
        fieldName: 'acceptShareDetails',
        label: '',
        type: 'checkbox',
        options: [
          {
            label: intl.formatMessage({
              id: 'field.acceptShareDetails.label',
              defaultMessage:
                'Ik ga akkoord met het delen van mijn gegevens met SmartTwin voor duurzaamheidsmaatregelen, energieadvies en eventuele aanvragen voor offertes.'
            }),
            value: 'true'
          }
        ],
        defaultValue: getDefaultValue('true')
      },
      acceptConditions: {
        fieldName: 'acceptConditions',
        label: '',
        type: 'checkbox',
        options: [
          {
            label: intl.formatMessage(
              {
                id: 'field.acceptConditions.label',
                defaultMessage: 'Ik ga akkoord met de {voorwaarden} en ik heb het {link} gelezen.'
              },
              {
                link: `<a href="https://smarttwin.nl/voor-organisaties/financieel-adviseurs/privacyverklaring/" class="underline-offset-4" target="_blank">${intl.formatMessage(
                  {
                    id: 'field.acceptConditions.portalLink',
                    defaultMessage: 'privacy statement'
                  }
                )}</a>`,
                voorwaarden: `<a href="https://smarttwin.nl/voor-organisaties/financieel-adviseurs/gebruiksvoorwaarden/" class="underline-offset-4" target="_blank">${intl.formatMessage(
                  {
                    id: 'field.acceptConditions.conditionsLink',
                    defaultMessage: 'voorwaarden'
                  }
                )}</a>`
              }
            ),
            value: 'true'
          }
        ],
        defaultValue: getDefaultValue('true')
      },
      houseNumber: {
        fieldName: 'houseNumber',
        label: intl.formatMessage({
          id: 'field.houseNumber.label',
          defaultMessage: 'Huisnummer'
        }),
        type: 'text',
        defaultValue: getDefaultValue('153')
      },
      houseNumberAddition: {
        fieldName: 'houseNumberAddition',
        label: intl.formatMessage({
          id: 'field.houseNumberAddition.label',
          defaultMessage: 'Toevoeging'
        }),
        type: 'text',
        defaultValue: getDefaultValue('B')
      },
      postalCode: {
        fieldName: 'postalCode',
        label: intl.formatMessage({
          id: 'field.postalCode.label',
          defaultMessage: 'Postcode'
        }),
        type: 'text',
        defaultValue: getDefaultValue('1034 BA')
      }
    };
  return sustainabilityScanFormFieldsConfig;
};
